import PolicyOutlineIcon from '@icons/PolicyOutlineIcon'

import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'

import { SOPsWorkspace } from '@pages/StandardOperatingProcess'
import { useSOPsFilters } from '@pages/StandardOperatingProcess/SOPsList'
import { useSOPNotificationIndicator } from '@pages/StandardOperatingProcess/SOPsNotifications/SOPsNotifications.hooks'

export default function SOPs({ size }) {
  const [{ sops }, updateFilters] = useSOPsFilters()
  const { data: hasUnreadSOPs } = useSOPNotificationIndicator()

  return (
    <>
      <IconButton
        id="sop-button"
        size={size}
        color="secondary"
        onClick={() => updateFilters({ sops: 'list' })}
        aria-label="SOPs toggler"
        data-testid="header-sops"
      >
        <Badge
          color="error"
          variant="dot"
          invisible={!hasUnreadSOPs}
          data-testid="header-sop-updates-badge"
          data-test-unread={hasUnreadSOPs}
        >
          <PolicyOutlineIcon style={{ fontSize: 20 }} />
        </Badge>
      </IconButton>
      <SOPsWorkspace open={Boolean(sops)} onClose={() => updateFilters({ sops: undefined, sopId: undefined })} />
    </>
  )
}
